import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const ChildrenDefaultSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <g clipPath="url(#clip0)">
      <path
        d="M6.46062 20.2737C5.61439 21.12 4.24422 21.1186 3.39982 20.2742C2.55443 19.4288 2.55309 18.0587 3.39932 17.2124"
        stroke="#D7E0EE"
        strokeWidth="2.70583"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1061 12.3635C22.6195 9.8501 22.6018 5.75423 20.0667 3.21905C17.5295 0.681918 13.4356 0.666216 10.9222 3.17962C9.36908 4.73276 8.81416 6.88369 9.19574 8.90199C9.19974 8.92544 9.18808 8.9371 9.19405 8.96251C9.51963 10.6721 8.75375 11.438 8.7032 11.4846L7.80319 12.3846L10.9011 15.4825L11.7836 14.6C11.7836 14.6 12.5589 13.758 14.3271 14.0956C14.3545 14.0996 14.3662 14.088 14.3896 14.092C16.4079 14.4735 18.5549 13.9147 20.1061 12.3635Z"
        fill="#D7E0EE"
      />
      <path
        d="M3.08234 7.60277C3.08234 7.60277 7.94295 16.8289 16.0703 20.5907"
        stroke="#D7E0EE"
        strokeWidth="3.24699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0 0H24V24H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </SvgWrapper>
)
